import { useQuery } from '@apollo/client/react';

import { GET_ALL_BANNER_QUERY } from '../../../src/client/cms/queries/banner-queries.gql';
import filterHomePageBanners from '../filter-home-page-banners';
import type { CmsBanner } from '../../../src/client/pages/home/types';

const useGetHomeBannersQuery = ({
  shouldSkip,
}: {
  shouldSkip: boolean;
}): { banners: CmsBanner[]; loading: boolean } => {
  const { data: cmsBannerData, loading } = useQuery(GET_ALL_BANNER_QUERY, { skip: shouldSkip });
  const banners = filterHomePageBanners(cmsBannerData?.allBanner);
  return { banners, loading };
};

export default useGetHomeBannersQuery;
